@if (loading()) {
	<div class="w-full vh-100 d-flex justify-content-center align-items-center">
		<mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
	</div>
} @else {
	<img [src]="imageSrc()" alt="skan" />
}
